import styled from 'styled-components';

import {
  Colors,
  Sizes,
} from '@noitada/shared/constants';



export interface IProps {
  disabled?: boolean;
}



export const PaymentChooseContainer = styled.a`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-top: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 12px;
  background-color: ${Colors.calendarColorLight};
  border-radius: ${Sizes.cardRadius}px;
  cursor: ${(props: IProps) => props.disabled ? 'default' : 'pointer'};
`;



export const PaymentInfoChooseView = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  margin-right: 10px;
`;

export const PaymentChooseTitle = styled.h1`
  margin-bottom: 4px;
  color: ${Colors.white};
  font-size: 14px;
  font-weight: 400;
`;

export const PaymentChooseCardNumber = styled.h2`
  margin-bottom: 2px;
  color: ${Colors.white};
  font-size: 18px;
  font-weight: bold;
  line-height: 24px;
`;

export const PaymentChooseSubtitle = styled.p`
  color: ${Colors.gray};
  font-size: 13px;
  line-height: 16px;
`;



export const PaymentCardView = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  padding-top: 5px;
`;

export const PaymentParcelsCardView = styled.p`
  margin-top: 10px;
  color: ${Colors.gray};
  font-size: 12px;
  line-height: 16px;
  text-align: right;
  letter-spacing: 2px;
`;
